// @flow
import React, { Component } from 'react';
import TimeInput from 'time-input';
import { FormControl, Col, Row, Button } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import style from './style';
import DaySelector from './components/DaySelector/DaySelector';
import locale from '../../../../../../locales/index';

import './timeInput.css';

class MedicationInput extends Component<{
  medication: Object,
  onChange: Function,
  onRemove: Function,
}, {
  time: string,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      time: props.medication.time,
    };
  }

  render() {
    const med = this.props.medication;

    return (<Row style={style.container}>
      <Col sm={3} style={style.col}>
        <FormControl
          defaultValue={this.props.medication.name}
          style={style.feedsInputs}
          type="text"
          placeholder={locale.medicationName}
          onChange={(e) => {
            med.name = e.target.value;
            this.props.onChange(med);
          }}
        />
      </Col>
      <Col sm={3} style={style.col}>
        <FormControl
          defaultValue={this.props.medication.amount}
          style={style.feedsInputs}
          type="text"
          placeholder={locale.medicationAmount}
          onChange={(e) => {
            med.amount = e.target.value;
            this.props.onChange(med);
          }}
        />
      </Col>
      <Col sm={2} style={style.col}>
        <DaySelector
          defaultValue={this.props.medication.days}
          onChange={(value: Array<boolean>) => {
            med.days = value;
            this.props.onChange(med);
          }}
        />
      </Col>
      <Col sm={2} style={style.col}>
        <TimeInput
          className="form-control"
          value={this.state.time}
          onChange={(value: string) => {
            this.setState({ time: value });
            med.time = value;
            this.props.onChange(med);
          }}
        />
      </Col>
      <Col sm={1} style={style.col}>
        <Button onClick={this.props.onRemove}><FontAwesome name="trash" /></Button>
      </Col>
    </Row>);
  }
}

export default MedicationInput;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Medication/components/MedicationInput/MedicationInput.js